import padStart from './padStart';
/* eslint-disable */

if (!String.prototype.padStart) {
  String.prototype.padStart = padStart;
}
/* eslint-enable */